module.exports = "/_next/static/images/newslettersignupimage-a8e39fba057e06d2f54130c5aecc2fb8.jpg";